/* Defy Sports 2026 — Navigation JS */
(function () {
  'use strict';

  /* ── Announcement bar rotation ──────────────────────────── */
  var annText = document.querySelector('.defy-announcement__text');
  if (annText && annText.dataset.messages) {
    var msgs = annText.dataset.messages.split('|');
    var idx = 0;
    setInterval(function () {
      idx = (idx + 1) % msgs.length;
      annText.style.opacity = '0';
      setTimeout(function () {
        annText.textContent = msgs[idx];
        annText.style.opacity = '1';
      }, 300);
    }, 4000);
  }

  /* ── Announcement bar close ─────────────────────────────── */
  var annClose = document.querySelector('[data-defy-announcement-close]');
  var annBar = document.getElementById('defy-announcement');
  if (annClose && annBar) {
    annClose.addEventListener('click', function () {
      annBar.style.height = annBar.offsetHeight + 'px';
      requestAnimationFrame(function () {
        annBar.style.transition = 'height 250ms, opacity 250ms';
        annBar.style.height = '0';
        annBar.style.opacity = '0';
        annBar.style.overflow = 'hidden';
      });
    });
  }

  /* ── Desktop dropdown toggle ────────────────────────────── */
  document.querySelectorAll('.defy-nav__link[aria-expanded]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var expanded = this.getAttribute('aria-expanded') === 'true';
      // Close all others
      document.querySelectorAll('.defy-nav__link[aria-expanded="true"]').forEach(function (other) {
        if (other !== btn) {
          other.setAttribute('aria-expanded', 'false');
          var otherDrop = other.nextElementSibling;
          if (otherDrop) otherDrop.classList.remove('is-open');
        }
      });
      this.setAttribute('aria-expanded', String(!expanded));
      var dropdown = this.nextElementSibling;
      if (dropdown) dropdown.classList.toggle('is-open', !expanded);
    });
  });

  // Close dropdowns on outside click
  document.addEventListener('click', function (e) {
    if (!e.target.closest('.defy-nav__item')) {
      document.querySelectorAll('.defy-nav__link[aria-expanded="true"]').forEach(function (btn) {
        btn.setAttribute('aria-expanded', 'false');
        var dropdown = btn.nextElementSibling;
        if (dropdown) dropdown.classList.remove('is-open');
      });
    }
  });

  /* ── Mobile menu ────────────────────────────────────────── */
  var menuToggle = document.querySelector('[data-defy-menu-toggle]');
  var mobileMenu = document.getElementById('defy-mobile-menu');
  var hamburger  = document.querySelector('.defy-header__hamburger');

  function openMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.add('is-open');
    mobileMenu.setAttribute('aria-hidden', 'false');
    if (hamburger) hamburger.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    if (!mobileMenu) return;
    mobileMenu.classList.remove('is-open');
    mobileMenu.setAttribute('aria-hidden', 'true');
    if (hamburger) hamburger.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  if (menuToggle) menuToggle.addEventListener('click', openMenu);
  document.querySelectorAll('[data-defy-menu-close]').forEach(function (el) {
    el.addEventListener('click', closeMenu);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeMenu();
  });

  /* ── Mobile sub-menu accordion ──────────────────────────── */
  document.querySelectorAll('[data-defy-mobile-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var sub = this.nextElementSibling;
      if (sub) sub.classList.toggle('is-open');
    });
  });

  /* ── Sort select redirect ───────────────────────────────── */
  var sortSelect = document.querySelector('[data-defy-sort]');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', this.value);
      window.location.href = url.toString();
    });
  }

  /* ── Sales pop CSS injection (if not in stylesheet) ─────── */
  if (!document.querySelector('#defy-sales-pop-css')) {
    var style = document.createElement('style');
    style.id = 'defy-sales-pop-css';
    style.textContent = [
      '.defy-sales-pop{position:fixed;bottom:24px;left:24px;z-index:9999;transform:translateX(-120%);transition:transform 400ms cubic-bezier(0.23,1,0.32,1);max-width:320px;pointer-events:none}',
      '.defy-sales-pop.is-visible{transform:translateX(0);pointer-events:all}',
      '.defy-sales-pop__inner{display:flex;align-items:center;gap:12px;background:#1a1a1a;border:1px solid #2a2a2a;border-radius:12px;padding:14px 16px;box-shadow:0 8px 32px rgba(0,0,0,.6)}',
      '.defy-sales-pop__icon{font-size:24px;flex-shrink:0}',
      '.defy-sales-pop__text{flex:1;display:flex;flex-direction:column;gap:2px}',
      '.defy-sales-pop__text strong{font-size:13px;color:#fff;font-weight:700}',
      '.defy-sales-pop__text span{font-size:12px;color:rgba(255,255,255,.5)}',
      '.defy-sales-pop__close{background:none;border:none;color:rgba(255,255,255,.3);cursor:pointer;font-size:14px;padding:0;flex-shrink:0;line-height:1}'
    ].join('');
    document.head.appendChild(style);
  }

})();

/* ============================================================
   DEFY SPORTS 2026 — Search Overlay JS
   Toggle · Predictive search API · Keyboard nav
   ============================================================ */
(function () {
  'use strict';
  var overlay    = document.getElementById('defy-search-overlay');
  var input      = document.getElementById('defy-search-input');
  var resultsEl  = document.getElementById('defy-search-results');
  var popularEl  = document.getElementById('defy-search-popular');
  if (!overlay) return;

  function openSearch() {
    overlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (input) setTimeout(function () { input.focus(); }, 50);
  }
  function closeSearch() {
    overlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (input) input.value = '';
    if (resultsEl) { resultsEl.innerHTML = ''; resultsEl.classList.remove('has-results'); }
    if (popularEl) popularEl.style.display = '';
  }

  /* Toggle buttons */
  document.querySelectorAll('[data-defy-search-toggle]').forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
  });
  document.querySelectorAll('[data-defy-search-close]').forEach(function (el) {
    el.addEventListener('click', closeSearch);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closeSearch();
  });

  /* Intercept form submit to scope query to title+tag only */
  var searchForm = document.querySelector('.defy-search-overlay__form');
  if (searchForm) {
    searchForm.addEventListener('submit', function (e) {
      e.preventDefault();
      var q = input ? input.value.trim() : '';
      if (q) {
        var scoped = 'title:' + q + ' OR tag:' + q;
        window.location.href = '/search?type=product&q=' + encodeURIComponent(scoped);
      }
    });
  }

  /* Predictive search */
  var searchTimer;
  if (input) {
    input.addEventListener('input', function () {
      clearTimeout(searchTimer);
      var q = input.value.trim();
      if (q.length < 2) {
        if (resultsEl) { resultsEl.innerHTML = ''; resultsEl.classList.remove('has-results'); }
        if (popularEl) popularEl.style.display = '';
        return;
      }
      searchTimer = setTimeout(function () { fetchResults(q); }, 250);
    });
  }

  function fetchResults(q) {
    var url = '/search/suggest.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,product_type,tag';
    fetch(url)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var products = (data.resources && data.resources.results && data.resources.results.products) || [];
        renderResults(products, q);
      })
      .catch(function () {});
  }

  function formatMoney(price) {
    var num = parseFloat(price);
    if (isNaN(num)) return '';
    return '\u20AC' + num.toFixed(2);
  }

  function renderResults(products, q) {
    if (!resultsEl) return;
    if (products.length === 0) {
      resultsEl.innerHTML = '<p class="defy-search-overlay__no-results">No products found for \u201C' + q + '\u201D</p>';
      resultsEl.classList.remove('has-results');
      if (popularEl) popularEl.style.display = 'none';
      return;
    }
    var html = '';
    products.forEach(function (p) {
      var imgUrl = p.featured_image && p.featured_image.url ? p.featured_image.url : (typeof p.featured_image === 'string' ? p.featured_image : null);
      var imgTag = imgUrl
        ? '<div class="defy-search-result-card__img"><img src="' + imgUrl + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy"></div>'
        : '<div class="defy-search-result-card__img"></div>';
      var price = p.price ? '<span class="defy-search-result-card__price">' + formatMoney(p.price) + '</span>' : '';
      html += '<a href="' + p.url + '" class="defy-search-result-card">' + imgTag + '<div class="defy-search-result-card__body"><span class="defy-search-result-card__title">' + p.title + '</span>' + price + '</div></a>';
    });
    var scopedQ = 'title:' + q + ' OR tag:' + q;
    resultsEl.innerHTML = html + '<a href="/search?type=product&q=' + encodeURIComponent(scopedQ) + '" class="defy-search-overlay__view-all">View all results &rarr;</a>';
    resultsEl.classList.add('has-results');
    if (popularEl) popularEl.style.display = 'none';
  }
})();

